import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { factoryList } from '../data/factories';
import DropZone from '../components/FileUpload/DropZone';
import { FileType } from '../types/media';

const fileTypes: { id: FileType; name: string }[] = [
  { id: 'shutdown', name: 'Shutdown' },
  { id: 'monthly_meeting', name: 'Réunion mensuelle' },
  { id: 'health_safety', name: 'Santé sécurité' },
  { id: 'vs', name: 'VS' },
  { id: 'general_info', name: 'Information générale' }
];

const UploadPage: React.FC = () => {
  const navigate = useNavigate();
  const [selectedFactory, setSelectedFactory] = useState<string>('');
  const [selectedType, setSelectedType] = useState<FileType>('monthly_meeting');

  const handleUploadComplete = () => {
    // Navigate to the factory page after successful upload
    if (selectedFactory) {
      navigate(`/usine/${selectedFactory}`);
    }
  };

  return (
    <div className="animate-fade-in">
      <div className="flex items-center mb-4 sm:mb-6">
        <button 
          onClick={() => navigate(-1)}
          className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 mr-2"
          aria-label="Retour"
        >
          <ArrowLeft className="w-5 h-5 text-gray-700 dark:text-gray-200" />
        </button>
        
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">
          Télécharger des fichiers
        </h1>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-4 sm:p-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
          {/* Factory Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Sélectionner une usine
            </label>
            <select
              value={selectedFactory}
              onChange={(e) => setSelectedFactory(e.target.value)}
              className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm sm:text-base"
            >
              <option value="">Choisir une usine...</option>
              {factoryList.map(factory => (
                <option key={factory.id} value={factory.id}>
                  {factory.name}
                </option>
              ))}
            </select>
          </div>

          {/* File Type Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Type de fichier
            </label>
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value as FileType)}
              className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm sm:text-base"
            >
              {fileTypes.map(type => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {selectedFactory ? (
          <DropZone 
            factoryId={selectedFactory}
            onUploadComplete={handleUploadComplete}
            fileType={selectedType}
          />
        ) : (
          <div className="text-center py-8 sm:py-12 text-gray-500 dark:text-gray-400">
            Veuillez sélectionner une usine pour commencer le téléchargement
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadPage;